/* eslint
    default-case: "warn",
    consistent-return: "warn"
*/

import {
  EasyfyEventData,
  IDataMapper,
  IEasyfyEvent
} from '@shared/easyfy.events/easyfy.eventdata';
import { EventNames } from '@shared/easyfy.events/easyfy.eventhandler';
import { MedsEventData } from './meds.eventdata';

/* Exporter class */
export class KlaviyoDataMapper implements IDataMapper {
  static CheckoutUrl: string = '/kassa';

  MapEventData(event: IEasyfyEvent): any {
    let mappedEvent: any;

    switch (event.eventName.toLowerCase()) {
      case EventNames.ProductPageView: {
        mappedEvent = this.ViewItemEvent(event);
        break;
      }
      case EventNames.AddToCart: {
        mappedEvent = this.AddToCartEvent(event);
        break;
      }
      case EventNames.RemoveFromCart: {
        mappedEvent = this.AddToCartEvent(event);
        break;
      }
      case EventNames.StartedCheckout: {
        mappedEvent = this.StartedCheckoutEvent(event);
        break;
      }
      default: {
        console.warn(`KlaviyoDataMapper: No mapping found for ${event.eventName}`);
      }
    }
    return mappedEvent;
  }

  ViewItemEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) {
      return;
    }

    const product = MedsEventData.Product(event.data.productIdentifier);

    const item = {
      price: product.Price,
      productId: product.Id,
      productName: product.DisplayName,
      sku: product.Id,
      imageUrl: this.GetImageUrl(product.ProductImageUrl),
      url: this.GetUrl(product.RelativeProductUrl),
      brand: product.Brand,
      categories:
        product.Categories.length > 0 ? product.Categories.toString() : null
    };

    const klaviyoEvent = {
      event: 'Viewed Product',
      data: {
        item
      }
    };

    return klaviyoEvent;
  }

  AddToCartEvent(event: IEasyfyEvent): any {
    const basket = EasyfyEventData.Basket();

    if (!basket || basket.rows.length === 0) {
      return;
    }

    const items: any[] = [];
    const itemNames: string[] = [];
    const categories: string[] = [];

    basket.rows.forEach((basketProduct) => {
      const product = MedsEventData.Product(basketProduct.productIdentifier);

      items.push({
        itemPrice: product.Price,
        productId: product.Id,
        productName: product.DisplayName,
        brand: product.Brand,
        categories:
          product.Categories.length > 0 ? product.Categories.toString() : null,
        quantity: basketProduct.qty,
        rowTotal: product.Price * basketProduct.qty,
        productUrl: this.GetUrl(product.RelativeProductUrl),
        imageUrl: this.GetImageUrl(product.ProductImageUrl),
        sku: product.Id
      });

      itemNames.push(product.DisplayName);
      categories.push(product.Categories.toString());
    });

    const klaviyoEvent = {
      event: 'Add to cart',
      data: {
        $value: basket.priceIncVat,
        itemNames: itemNames.toString(),
        checkoutUrl: this.GetUrl(KlaviyoDataMapper.CheckoutUrl),
        categories: categories.toString(),
        products: items
      }
    };

    return klaviyoEvent;
  }

  StartedCheckoutEvent(event: IEasyfyEvent): any {
    if (
      !event.data.checkoutProducts ||
      event.data.checkoutProducts.length === 0
    ) {
      return;
    }

    const items: any[] = [];
    let value: number = 0;
    const itemNames: string[] = [];
    const categories: string[] = [];

    event.data.checkoutProducts.forEach((checkoutProduct) => {
      const product = MedsEventData.Product(checkoutProduct.productIdentifier);

      items.push({
        itemPrice: product.Price,
        productId: product.Id,
        productName: product.DisplayName,
        brand: product.Brand,
        categories:
          product.Categories.length > 0 ? product.Categories.toString() : null,
        quantity: checkoutProduct.qty,
        rowTotal: product.Price * checkoutProduct.qty,
        productUrl: this.GetUrl(product.RelativeProductUrl),
        imageUrl: this.GetImageUrl(product.ProductImageUrl),
        sku: product.Id
      });

      value += product.PriceExVat * checkoutProduct.qty;
      itemNames.push(product.DisplayName);
      categories.push(product.Categories.toString());
    });

    const klaviyoEvent = {
      event: 'Started Checkout',
      data: {
        $value: value,
        itemNames: itemNames.toString(),
        checkoutUrl: this.GetUrl(KlaviyoDataMapper.CheckoutUrl),
        categories: categories.toString(),
        products: items
      }
    };

    return klaviyoEvent;
  }

  GetImageUrl(imageUrl: string): string {
    if (!imageUrl) {
      return '';
    }

    imageUrl = imageUrl
      .replace('/0/', '/108/')
      .replace('/0/', '/108/')
      .replace('/auto/', '/fill/');

    return imageUrl;
  }

  GetUrl(url: string): string {
    url = `${location.protocol}//${location.host}${url}`;
    return url;
  }
}
